import { useEffect } from 'react';

/**
 * Finding 35: the browser Back button must never leave the app. Popping past
 * the SPA's first history entry landed users on whatever came before the app
 * (in the worst case the login flow), which read as "the program shut down and
 * my session is gone" — mid-work, with no warning.
 *
 * Arm one same-URL history entry as the app FLOOR, mounted with the
 * authenticated Layout. Whenever a pop lands ON the floor entry, re-push it:
 * Back at the floor is absorbed and the user stays in the app. In-app route
 * back (the URL actually changes between router entries) is untouched — only
 * the exit past the floor is swallowed.
 */
export function useAppBackFloor(): void {
  useEffect(() => {
    window.history.pushState({ a5floor: true }, '');

    const onPopState = () => {
      if ((window.history.state as { a5floor?: boolean } | null)?.a5floor) {
        // Back consumed the floor — swallow it and stay in the app.
        window.history.pushState({ a5floor: true }, '');
      }
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
}
